import script from "./BlockListening.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockListening.vue?vue&type=script&setup=true&lang=js"

import "./BlockListening.vue?vue&type=style&index=0&id=c774d31e&lang=css"

const __exports__ = script;

export default __exports__